import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Flex, Heading, Text, VStack, Divider } from '@chakra-ui/react';

const CommentCard = ({ comment, defaultShow }) => {
  const [showComment, setShowComment] = useState(defaultShow);
  const toggleComment = () => setShowComment((prev) => !prev);

  return (
    <Box width={'100%'}>
      <Flex justify="flex-end" mb={2}>
        <Text
          color="blue.500"
          cursor="pointer"
          textDecoration="underline"
          onClick={toggleComment}
        >
          {showComment ? 'Hide Comments' : 'Show Comments'}
        </Text>
      </Flex>

      {showComment && (
        <Box
          p={4}
          borderWidth="1px"
          borderRadius="lg"
          boxShadow="md"
          bg="green.50"
          mb={4}
        >
          <VStack align="start" spacing={4}>
            <Heading size="md" color="teal.700">
              Comments
            </Heading>
            <Divider />
            <Box>
              <Text textAlign="justify" color="gray.700">
                {comment}
              </Text>
            </Box>
          </VStack>
        </Box>
      )}
    </Box>
  );
};

CommentCard.propTypes = {
  comment: PropTypes.string,
  defaultShow: PropTypes.bool,
};

export default CommentCard;
